export default function initIntroStatement() {
    const section = document.querySelector('[data-intro-statement]');
    if (!section) return;
    const textEl = section.querySelector('[data-intro-text]');
    if (!textEl) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Split text into word spans
    const original = textEl.textContent;
    const words = original.split(/\s+/).filter(Boolean);
    textEl.textContent = '';
    const spans = words.map((w, i) => {
        const span = document.createElement('span');
        span.className = 'word';
        span.textContent = w;
        // delay each word slightly for staggered reveal at the same scroll progress threshold
        span.style.transitionDelay = `${Math.min(i * 0.03, 0.6)}s`;
        textEl.appendChild(span);
        if (i < words.length - 1) textEl.appendChild(document.createTextNode(' '));
        return span;
    });

    let ticking = false;

    const update = () => {
        ticking = false;
        const rect = section.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        // progress: starts when section top passes 70% of viewport, ends at center
        const start = vh * 0.7;
        const end = vh * 0.3;
        const raw = (start - rect.top) / (start - end);
        const progress = Math.min(1, Math.max(0, raw));

        spans.forEach((span, i) => {
            const threshold = i / Math.max(1, spans.length - 1);
            if (progress >= threshold * 0.9) {
                span.classList.add('is-visible');
            } else {
                span.classList.remove('is-visible');
            }
        });
    };

    const onScroll = () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
}
